import React from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, isContentfulString } from '@philips-internal/oswald-ui-utils';
import { Text } from '../text/text.js';
import { CountryFlagProperties } from './country-flag-types.js';
import './country-flag.css';
function CountryFlag(props) {
    const code = props.code?.toLowerCase() ?? CountryFlagProperties.code.defaultValue;
    const expression = `tws.phone-number.${code}`;
    const translatedExpression = MessageService.translate(expression);
    const name = expression !== translatedExpression
        ? translatedExpression
        : '';
    const className = classNames({
        'c-country-flag__wrapper': true,
        'c-country-flag__wrapper--reverse': Boolean(props.reverse),
    });
    return (React.createElement("div", { className: className },
        props.showName && isContentfulString(name) ? (React.createElement(Text, { value: name })) : null,
        React.createElement("span", { className: `c-country-flag u-flag-icon u-flag-icon--${code}` })));
}
export { CountryFlag, };
//# sourceMappingURL=country-flag.js.map